import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { VscClose } from "react-icons/vsc";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  userNotificationAction,
  markNotificationAsRead,
} from "../../features/user/reducer/userNotificationsReducer"; // Import your mark as read action
import moment from "moment";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import userServices from "../../features/user/userAction";

const HervestNotification = ({ show, close }) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector((state) => state.userNotifications);

  useEffect(() => {
    dispatch(userNotificationAction());
  }, [dispatch]);

  const handleOnDragEnd = async (result) => {
    if (!result.destination) return;
    const { destination, source } = result;

    if (destination.droppableId === "read") {
      const res = await userServices.markNotificationAsRead(
        notifications[source.index].id
      );
      if (res) {
        toast.success("Notification marked as read");
        dispatch(userNotificationAction());
      }
    }
  };

  return (
    <>
      <Transition.Root show={show} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-y-auto z-50"
          initialFocus={true}
          onClose={() => show}
        >
          <div className="flex mt-12 mr-5 justify-end min-h-screen relative">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="bg-white flex pb-10 w-80 flex-col justify-start items-center rounded-lg overflow-hidden shadow-xl transform transition-all">
                <div className="p-4 sm:p-6 w-full">
                  <Dialog.Title className="text-[#5B2E4F] text-center flex justify-between items-center text-2xl font-bold mb-4">
                    Notifications
                    <VscClose
                      onClick={close}
                      size={30}
                      className="text-primary text-right cursor-pointer"
                    />
                  </Dialog.Title>
                </div>

                <div className="flex flex-col space-y-4 w-full px-4">
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="read">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className="mt-4 bg-gray-100 p-2 rounded-lg"
                        >
                          <p className="text-sm text-center text-gray-500">
                            Drag here to mark as read
                          </p>
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>

                    <Droppable droppableId="notifications">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className="space-y-2"
                        >
                          {notifications?.map((notification, index) => (
                            <Draggable
                              key={notification.id}
                              draggableId={notification.id.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <motion.div
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  ref={provided.innerRef}
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  transition={{ duration: 0.5 }}
                                  whileHover={{ scale: 1.03 }}
                                  className="flex flex-col space-y-2 w-full hover:bg-primary hover:bg-opacity-10 p-4 rounded-lg"
                                >
                                  <div className="flex justify-between items-center w-full">
                                    <p className="text-[#5B2E4F] text-sm BoldFonter ">
                                      {notification.context}
                                    </p>
                                  </div>
                                  <p className="text-[#5B2E4F] text-sm font-normal">
                                    {notification.message}
                                  </p>
                                  <p className="text-[#5B2E4F] text-right text-xs font-bold">
                                    {moment(notification.createdAt).format(
                                      "MMMM Do YYYY, h:mm a"
                                    )}
                                  </p>
                                </motion.div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default HervestNotification;
